<template>
    <div class="container">
        <router-view :key="$route.path"/>
    </div>
</template>

<script>
    export default {

    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/app/manager/Index.vue